<template>
<div class="export-single-sheets">
  <h2>Fiches Formation</h2>
  <btn size="lg"
       class="export-button"
       type="techSheet"
       @click="exportSingleSheet('toolsUsage')">
    Formation
  </btn>
  <save-blob :target="csv.target"></save-blob>
  <modal v-model="show"
         size="lg"
         :backdrop="false"
         :keyboard="false"
         :footer="false"
         :header="false">
    <div class="export-modal">
      <div class="row">
        <div class="col-xs-12">
          <steps :steps="iterator.steps" :stepStates="iterator.stepStates"></steps>
        </div>
      </div>
      <div v-if="completed">
        <btn @click="hide" type="default">Retour</btn>
      </div>
    </div>
  </modal>
</div>
</template>

<script>
import stringify from 'csv-stringify'
import StepIterator from '@/sui/tools/stepiterator'
import stepsViewer from '@/sui/components/steps'
import saveBlob from '@/sui/components/saveblob'
import assert from '@/sui/tools/assert'
import ice from '@/sui/tools/ice'

import toolsUsageFlatten from '@/sui/data/flatten/toolsUsage'
import toolsUsageSheet from '@/sui/data/sheets/edit/toolsUsage'

import moment from 'moment'

export default {
  name: 'export-single-sheets',

  props: {
    year: {
      type: String,
      required: true
    },

    dataset: {
      type: String
    },

    surveillances: {
      type: Array,
      required: true
    }
  },

  data: function () {
    const steps = [
      {
        title: 'Récupération des fiches',
        error: null,
        run: function (vm, data, iteration) {
          if (iteration === 0) {
            assert.isArray(vm.surveillances)
            const ids = []
            for (let i = 0; i !== vm.surveillances.length; ++i) {
              ids.push(vm.surveillances[i].id)
            }
            this.error = null
            const instance = this
            var request = {
              y: parseInt(vm.year),
              ids: ids
            }

            vm.$store.dispatch(`singlesheets/${vm.cfg.routeSuffix}`, request).then(
              (response) => {
                if (response.data.err == null) {
                  data.full = ice.freeze(response.data.v)
                } else {
                  instance.error = response.data.err
                }
              }
            ).catch(e => { instance.error = e })
          }
          return {
            end: data.full != null || this.error != null,
            success: this.error == null
          }
        },
        setError: function (e) {
          return `Erreur lors de la récupération des fiches : ${e}.`
        }
      },

      {
        title: 'Mise à plat des fiches',
        run: function (vm, data, iteration) {
          assert(iteration === 0)

          const flatten = vm.cfg.flatten[vm.year]
          assert.notNull(flatten)
          assert.isFunction(flatten)

          const definition = vm.cfg.sheet[vm.year]
          assert.notNull(definition)
          const tree = definition.fields

          const sorted = data.full.slice().sort(
            (f, s) => f.sv.localeCompare(s.sv)
          )

          data.out = flatten({
            type: vm.type,
            treeFields: tree,
            sheets: sorted,
            onlyClosed: true,
            surveillances: vm.surveillances
          })

          return {
            end: true,
            success: true
          }
        },

        setError: function (e) {
          return `Erreur lors de la mise à plat des fiches: ${e}.`
        }
      },

      {
        title: 'Export du fichier',
        end: false,
        success: false,

        run: function (vm, data, iteration) {
          const instance = this
          if (iteration === 0) {
            this.end = false
            this.success = false
            this.output = null
            stringify(
              data.out.sheets,
              data.out.options,
              function (err, output) {
                if (err != null) {
                  instance.end = true
                  instance.success = false
                  instance.errorDetail = err
                  instance.setError()
                } else {
                  instance.end = true
                  instance.success = true
                  instance.output = output
                }
              }
            )
          }

          if (this.end && this.success) {
            setTimeout(
              function () {
                const date = moment().format('DD-MM-YYYY-HH-mm-ss')
                vm.csv.target = { filename: `${vm.cfg.filename} - ${date}.csv`, blob: new Blob([instance.output], { type: 'text/plain' }) }
              }, 10)
          }
          return {
            end: this.end,
            success: this.success,
            error: this.error
          }
        },
        setError: function (e) {
          return `Erreur lors de la création du fichier d'export: ${e}`
        }
      }
    ]

    return {
      type: '',
      show: false,
      csv: {
        target: null
      },
      iterator: new StepIterator(steps)
    }
  },

  computed: {
    cfg: function () {
      if (this.type === 'toolsUsage') {
        return {
          flatten: toolsUsageFlatten,
          routeSuffix: 'allToolsUsage',
          filename: 'Fiches Formation',
          sheet: toolsUsageSheet
        }
      }

      return null
    },

    completed: function () {
      return this.iterator.completed
    },

    version: function () {
      return parseInt(this.year) - 2018
    }
  },

  watch: {
    show: function (value) {
      if (!value) {
        this.iterator.reset()
      }
    }
  },

  methods: {
    exportSingleSheet: function (type) {
      this.type = type
      this.iterator.start(this)
      this.show = true
    },

    hide: function () {
      this.show = false
    }
  },

  components: {
    'save-blob': saveBlob,
    'steps': stepsViewer
  }

}
</script>
<style scoped lang="less">
.export-infections-data {
  .export-button {
    margin: 0.3rem;
  }
}
</style>
